import { useState } from 'react';
import Icon from '../AppIcon';
import { LEGAL_DOCUMENTS } from '../../constants/legalDocuments';
import LegalDocumentModal from './LegalDocumentModal';
import { formatBuildTooltip, getAppBuild } from '../../utils/appBuild';

const DOC_ICONS = {
  privacy: 'Shield',
  terms: 'FileText',
  cookies: 'Cookie',
  dpa: 'Database',
};

const LegalFooter = ({ className = '' }) => {
  const [activeDocumentId, setActiveDocumentId] = useState(null);
  const year = new Date().getFullYear();
  const build = getAppBuild();

  return (
    <>
      <footer
        className={`relative mt-8 sm:mt-12 w-full overflow-hidden border-t border-border/50 bg-gradient-to-r from-background via-surface/30 to-background pb-[max(0.5rem,env(safe-area-inset-bottom))] ${className}`}
      >
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/25 to-transparent"
        />

        <div className="relative px-3 py-3 sm:px-4 sm:py-2.5">
          {/* Mobile & tablet: wrap; desktop: single row */}
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 sm:gap-x-2.5 max-w-4xl mx-auto">
            <span className="inline-flex items-center justify-center gap-1.5 text-xs sm:text-[11px] text-muted-foreground/80 font-medium tracking-wide">
              <Icon name="Scale" size={13} className="text-primary/70 shrink-0" />
              <span>© {year} MAAP Limited</span>
            </span>

            <span
              aria-hidden="true"
              className="hidden sm:block h-3.5 w-px bg-border/70 shrink-0"
            />

            <nav
              aria-label="Legal documents"
              className="flex flex-wrap items-center justify-center gap-1.5 sm:gap-1 w-full sm:w-auto"
            >
              {LEGAL_DOCUMENTS.map((doc) => (
                <button
                  key={doc.id}
                  type="button"
                  onClick={() => setActiveDocumentId(doc.id)}
                  className="group inline-flex items-center justify-center gap-1.5 rounded-full px-3 py-2 sm:px-2.5 sm:py-1 min-h-[44px] sm:min-h-0 text-xs sm:text-[11px] text-muted-foreground transition-all duration-200 hover:bg-primary/8 hover:text-primary active:bg-primary/12 touch-manipulation"
                >
                  <Icon
                    name={DOC_ICONS[doc.id] || 'FileText'}
                    size={12}
                    className="opacity-50 transition-opacity group-hover:opacity-100 shrink-0"
                  />
                  <span className="font-medium">{doc.shortTitle}</span>
                </button>
              ))}
            </nav>
          </div>

          <span
            className="pointer-events-none absolute bottom-1.5 right-2.5 select-none text-[9px] leading-none tracking-wide text-muted-foreground/35 sm:bottom-2 sm:right-3"
            title={formatBuildTooltip(build.id)}
            aria-label={`App version ${build.id}`}
          >
            v{build.id}
          </span>
        </div>
      </footer>

      {activeDocumentId && (
        <LegalDocumentModal
          documentId={activeDocumentId}
          onClose={() => setActiveDocumentId(null)}
        />
      )}
    </>
  );
};

export default LegalFooter;
